const reloadApplication = router => {
  window.location.pathname = router.history.pending.fullPath
}

export const notifyUserToReload = router => {
  const reloadDialog = document.createElement('dialog')
  reloadDialog.setAttribute('open', true)
  reloadDialog.className = 'v-dialog__content v-dialog__content--active'

  const reloadDialogContent = document.createElement('div')
  reloadDialogContent.className = 'v-dialog v-dialog--active v-dialog--persistent'
  reloadDialogContent.style = 'transform-origin: center center; width: 500px;'
  reloadDialog.appendChild(reloadDialogContent)

  const card = document.createElement('div')
  card.className = 'v-card v-sheet theme--light'
  reloadDialogContent.appendChild(card)

  const cardContent = document.createElement('div')
  cardContent.className = 'v-card__text'
  cardContent.innerHTML = `
    <div class="row">
      <div class="col-12 pt-10">
        <p class="text-body-1">New version of the app available. Please, refresh now.</p>
      </div>
    </div>
  `
  card.appendChild(cardContent)

  const cardActions = document.createElement('div')
  cardActions.className = 'v-card__actions'
  cardContent.appendChild(cardActions)

  const button = document.createElement('button')
  button.onclick = _ => reloadApplication(router)
  button.textContent = 'Reload'
  button.className = 'v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary'
  cardActions.appendChild(button)

  document.getElementById('app').getElementsByClassName('v-application--wrap')[0].appendChild(reloadDialog)
}
